import axiosInstance from "./axios.instance";
import { setAuthToken } from "./auth.utils";
import { ApiService } from "./api.service";
import apiEndPoints from "../app/routeConfig";

const apiService = new ApiService();

export class AuthService {
  async login(data) {
    let result;
    try {
      const response = await axiosInstance.post(`${apiEndPoints.login}`, data);
      if (response) {
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem('refreshToken', response.data.refreshToken);
        localStorage.setItem("userData", JSON.stringify(response.data.user));
        setAuthToken();
        result = response.data;
      }
    } catch (error) {
      result = error
    }
    return result
  }
}

export const useLogout = () => {
  const logout = async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      const logoutData = refreshToken ? { refreshToken } : {};

      // Call logout endpoint
      await apiService.post(`${apiEndPoints.logout}`, logoutData);

      // Clear all local storage and session storage
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('userData');
      sessionStorage.clear();

      // Clear axios default headers
      delete axiosInstance.defaults.headers.common['Authorization'];

      return true;
    } catch (error) {
      // Even if logout API fails, clear tokens locally
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('userData');
      sessionStorage.clear();
      delete axiosInstance.defaults.headers.common['Authorization'];

      console.error('Logout error:', error);
      throw error;
    }
  };
  return { logout };
};

